export default "__VITE_ASSET__Cbfdl28N__"